import React from "react";

import UseAnimations from 'react-useanimations'

import activity from 'react-useanimations/lib/activity'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            height: '90vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <UseAnimations fillColor="#00395f" size={50} animation={activity} />
          <br />
          <h2>Ocorreu um erro interno.</h2>
          <p>
            Ocorreu um erro interno no processamento da tela ou tarefa, caso o
            erro persista, entre em contato com o suporte de desenvolvimento.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
